export default {
    btns: {
        close: 'Close',
        minimize: 'Minimize',
        maximize: 'Maximize',
        restore: 'Restore',
        prev: 'Previous',
        next: 'Next',
        zoomIn: 'Zoom In',
        zoomOut: 'Zoom Out',
        rotate: 'Rotate',
        download: 'Download',
        preview: 'Preview',
        saveAs: 'Save As',
    },
    tips: {
        last: 'Last page',
        next: 'Next page',
        lastOne: 'This is the last one',
        firstOne: 'This is the first one',
        lastPage: 'This is the last page',
        firstPage: 'This is the first page',
        loading: 'loading',
        linkFailure: 'This link is unavailable',
        recalled: 'Message recalled',
        msgboxTitle: 'Hint',
        msgboxSubmitText: 'Confirm',
    },
    components: {
        imageViewer: {
            title: 'image viewer',
        },
    },
};
